import type { ConfluenceSubmitPromptOnPageCreateCommandProperties } from '@atlassian/rovo-content-bridge-api-commands';

import { fg } from '@confluence/feature-gating';

import { CommandHandler } from './types/command-handler-types';

export class SubmitPromptCommandHandler extends CommandHandler<
	ConfluenceSubmitPromptOnPageCreateCommandProperties,
	void
> {
	listen(params: ConfluenceSubmitPromptOnPageCreateCommandProperties): Promise<void> {
		if (this.properties.generateAIHeaderImage && fg('aifc_header_image_pseudo_title_enabled')) {
			return this.properties.generateAIHeaderImage({ adfContent: params.userPrompt });
		}

		return Promise.resolve();
	}
}
